import React, { useEffect, useState } from "react";
import Book from '../components/Book';
import { useNavigate, useParams } from "react-router-dom";
import {getData, postData, postFormData} from '../middleware/apiMiddleware';
import s from './item.module.css';
import {Image} from 'react-bootstrap';
import {GreenButton, BlueButton} from '../components/MyButton';
import {ItemConstant, getItemBasic} from '../middleware/MyConstant';
import MyTooltip from '../components/Utilities/MyTooltip';

const CategoryDisplay = ({itemId}) => {
	const navigate = useNavigate();

	const [categoryName, setCategoryName] = useState();

	const fetchData = () => {
		getData('item/getItemCategoryById?itemId=' + itemId, navigate)
		.then(res => {
				setCategoryName(res.data);
			}
		);
	}
	
	useEffect(() => {
		fetchData();
	}, []);
	
	return (<div className={s.itemDivCategoryDisplay}>{categoryName}</div>)
}


export default function Item() {
	const navigate = useNavigate();
	let params = useParams();
	const [itemId, setItemId] = useState(params.itemId);
	const [item, setItem] = useState(0);
	
	
	const nextId = async () => {
		const newItemId = parseInt(itemId) + 1; // Ensure you're working with numbers
		setItemId(newItemId.toString()); // Update state (optional, but good practice if you use itemId in the component's render)

		navigate(`/generalitem/${newItemId}`);
		window.location.reload(); 

	}
	
	const prevId = async () => {
		const newItemId = parseInt(itemId) - 1; // Ensure you're working with numbers
		setItemId(newItemId.toString()); // Update state (optional, but good practice if you use itemId in the component's render)

		navigate(`/generalitem/${newItemId}`);
		window.location.reload(); 
	}
	
	const updateKeyItemType = async (itemType, oldKeyType, newKeyType) => {
		let obj = {
			'id' : itemId,
			'itemType': itemType,
			'oldKeyType': oldKeyType,
			'newKeyType': newKeyType
		}
		
		await postData("item/updateKeyItemType", obj, navigate); 
		fetchData();
	}
	
	const fetchData = () => {
		getData('item/getItemBasicById?itemId=' + itemId, navigate)
		.then(res => {
				setItem(res.data);
			}
		);
	}
	
	const updateThumbnailPath = async (path) => {
		let obj = {
			itemId, path
		}
		await postData("item/updateThumbnailPath", obj, navigate); 
	}
	
	const generalItemUpload = async (selectedFile) => {

		try {
			const data = new FormData();
			data.append("itemId", itemId);
			data.append("generalfile", selectedFile);
      let res = await postFormData("utility/generalItemUpload", data, navigate);
			return res.data;
			
    } catch (err) {
			return null;
      console.log(err);
    }
	}
	
	useEffect(() => {
		fetchData();
	}, [itemId]);
	
	const ItemHolder = () => {
		if (ItemConstant.AllItemIts.includes(item.itemType)) {
				return (<div>
					<Book itemId={itemId} />
				</div>)
		}
		return (<div>no yet support</div>);
	}
	
	function displayItemType(itemType) {
		let itemObj = getItemBasic(itemType);
		return "" + itemObj.itemType + ' '+ itemObj.name;
	}

	return (<>
		<div className={s.basic}>
			<div className={s.titleRow}>
				<label htmlFor="imgs-upload">
					<Image className={s.thumbnailPath} fluid src={item.thumbnailPath} rounded />	
					<input id="imgs-upload" type="file" style={{display:"none"}} onChange={
						async (e) => {
								let path = await generalItemUpload(e.target.files[0]);
								if (path) {
									item.thumbnailPath = "https://ehla-media-bucket.s3.ap-southeast-1.amazonaws.com/" + path;
									setItem({...item});
									updateThumbnailPath(path);
								}
							}} />

				</label>
			</div>
			<div>
				<div style={{display:"flex", alignItems:"center", gap:"10px"}}>
					<div>Item: {itemId} [{displayItemType(item.itemType)}]</div>
					
					<MyTooltip msg={"&lt;page&gt;" +
												"item.js<br/><br/>" +
												"&lt;components&gt;<br/>" +
												"KeyItemBasic.js<br/>" + 
												"ItemVideo.js<br/>" + 
												"RelatedItems.js<br/>" + 
												"Book.js<br/>" + 
												"WordList.js<br/>" + 
												"SpeakingHints.js<br/>" + 
												"KeyListening.js<br/>" + 
												"VIPWriting.js<br/>" + 
												"SpeakingAnswers.js<br/>" + 
												"ItemQuestions.js<br/>" + 
												"ItemQuestionsOverview.js<br/>" + 
												"QuestionExplanation.js<br/>"} /> 
					<div>
						<BlueButton isEnabled={true} clickedAction={prevId} bText={"prev"} />
					</div>
					<div>
						<BlueButton isEnabled={true} clickedAction={nextId} bText={"next"} />
					</div>
				</div>
				
				{(item != 0) && (<NameDisplay itemId={itemId} itemType={item.itemType} nameInput={item.name} nameHkInput={item.tranJson.name_hk} shortNameInput={item.shortName} shortNameHkInput={item.tranJson?.short_name_hk}
					descriptionInput={item.description} descriptionHkInput={item.tranJson.description_hk}
				/>)}
				
				{ /*
					(ItemConstant.ListeningLabelIts.includes(item.itemType)) && (<div>
						<div style={{margin:"15px 10px", display:"flex", alignItems:"center"}}>
							<div style={{display:"flex"}}>
								<div style={{marginRight:"5px"}} 
									className={(item.itemType==74) ? s.toggleButtonChosen : s.toggleButtonOption}
									onClick={()=>{
										updateKeyItemType(74, "key-podcast", "key-listening");
									}}>Listening</div>
								<div style={{marginRight:"5px"}} 
									className={(item.itemType==75) ? s.toggleButtonChosen : s.toggleButtonOption}
									onClick={()=>{
										updateKeyItemType(75, "key-listening", "key-podcast");
									}}>Podcast</div>
							</div>
						</div>
					</div>)
				*/}
			</div>
		</div>
		<ItemHolder/>
	</>)
}



	
	const NameDisplay = ({itemId, itemType, nameInput, nameHkInput, shortNameInput, shortNameHkInput, descriptionInput, descriptionHkInput}) => {
		const navigate = useNavigate();
		const [name, setName] = useState(nameInput);
		const [nameHk, setNameHk] = useState(nameHkInput);
		const [shortName, setShortName] = useState(shortNameInput);
		const [shortNameHk, setShortNameHk] = useState(shortNameHkInput);
		const [description, setDescription] = useState(descriptionInput);
		const [descriptionHk, setDescriptionHk] = useState(descriptionHkInput);
		
		const updateName = async () => {
			let obj = { itemId, name }
			await postData("item/updateName", obj, navigate); 
		}
		const updateNameHk = async () => {
			let obj = { itemId, nameHk }
			await postData("item/updateNameHk", obj, navigate); 
		}
		const translateAndUpdateNameHk = async () => {
			let obj = { sentence:name }
			let s = await postData("utility/translateSentence", obj, navigate); 
			
			let hk = s.data;
			setNameHk(hk);
			obj = { itemId, nameHk: hk }
			await postData("item/updateNameHk", obj, navigate); 
		}
		const updateShortName = async () => {
			let obj = { itemId, shortName }
			await postData("item/updateShortName", obj, navigate); 
		}
		const updateShortNameHk = async () => {
			let obj = { itemId, shortNameHk }
			await postData("item/updateShortNameHk", obj, navigate); 
		}
		const translateAndUpdateShortNameHk = async () => {
			let obj = { sentence:shortName }
			let s = await postData("utility/translateSentence", obj, navigate); 
			
			let hk = s.data;
			setShortNameHk(hk);
			obj = { itemId, shortNameHk: hk }
			await postData("item/updateShortNameHk", obj, navigate); 
		}
		const updateDescription = async () => {
			let obj = { itemId, description }
			await postData("item/updateDescription", obj, navigate); 
		}
		const updateDescriptionHk = async () => {
			let obj = { itemId, descriptionHk }
			await postData("item/updateDescriptionHk", obj, navigate); 
		}
		const translateAndUpdateDescriptionHk = async () => {
			let obj = { sentence:description }
			let s = await postData("utility/translateSentence", obj, navigate); 
			
			let hk = s.data;
			setDescriptionHk(hk);
			obj = { itemId, descriptionHk: hk }
			await postData("item/updateDescriptionHk", obj, navigate); 
		}
	
		return (<div style={{display:"flex", flexDirection:"column", alignItems:"start", gap:"5px"}}>
			<div style={{display:"flex", flexDirection:"row", alignItems:"center", justifyContent:"start", gap:"5px", flexWrap:"wrap"}}>
				<div style={{width:"100px"}}>Name:</div>
				<input style={{width:"400px"}} className={s.inputBox} type="text" value={name} onChange={(e)=>{
					setName(e.target.value);
				}}/>
				<div>
					<GreenButton isEnabled={true} clickedAction={()=>updateName()} bText={"Update"} />
				</div>
			</div>
			<div style={{display:"flex", flexDirection:"row", alignItems:"center", justifyContent:"start", gap:"5px", flexWrap:"wrap"}}>
				<div style={{width:"100px"}}>HK Name:</div>
				<input style={{width:"400px"}} className={s.inputBox} type="text" value={nameHk} onChange={(e)=>{
					setNameHk(e.target.value);
				}}/>
				
				<div>
					<GreenButton isEnabled={true} clickedAction={()=>updateNameHk()} bText={"Update"} />
				</div>
				<div style={{marginLeft:"10px"}}>
					<GreenButton isEnabled={true} clickedAction={()=>translateAndUpdateNameHk()} bText={"Translate & Save"} />				
				</div>
			</div>
			<div style={{display:"flex", flexDirection:"row", alignItems:"center", justifyContent:"start", gap:"5px", flexWrap:"wrap"}}>
				<div style={{width:"100px"}}>Short Name:</div>
				<input style={{width:"400px"}} className={s.inputBox} type="text" value={shortName} onChange={(e)=>{
					setShortName(e.target.value);
				}}/>
				<div>
					<GreenButton isEnabled={true} clickedAction={()=>updateShortName()} bText={"Update"} />
				</div>
			</div>
			<div style={{display:"flex", flexDirection:"row", alignItems:"center", justifyContent:"start", gap:"5px", flexWrap:"wrap"}}>
				<div style={{width:"100px"}}>HK Short Name:</div>
				<input style={{width:"400px"}} className={s.inputBox} type="text" value={shortNameHk} onChange={(e)=>{
					setShortNameHk(e.target.value);
				}}/>
				
				<div>
					<GreenButton isEnabled={true} clickedAction={()=>updateShortNameHk()} bText={"Update"} />
				</div>
				<div style={{marginLeft:"10px"}}>
					<GreenButton isEnabled={true} clickedAction={()=>translateAndUpdateShortNameHk()} bText={"Translate & Save"} />				
				</div>
			</div>
			
			{
				(ItemConstant.IdeaIts.includes(itemType)) && (<>
					<div style={{display:"flex", flexDirection:"row", alignItems:"center", justifyContent:"start"}}>
						<div style={{width:"80px"}}>Desc:</div>
						<input className={s.inputBox} type="text" value={description} onChange={(e)=>{
							setDescription(e.target.value);
						}}/>
						<div>
							<GreenButton isEnabled={true} clickedAction={()=>updateDescription()} bText={"Update"} />
						</div>
					</div>
					<div style={{display:"flex", flexDirection:"row", alignItems:"center", justifyContent:"start"}}>
						<div style={{width:"80px"}}>HK Desc:</div>
						<input className={s.inputBox} type="text" value={descriptionHk} onChange={(e)=>{
							setDescriptionHk(e.target.value);
						}}/>
						
						<div>
							<GreenButton isEnabled={true} clickedAction={()=>updateDescriptionHk()} bText={"Update"} />
						</div>
						<div>
							<GreenButton isEnabled={true} clickedAction={()=>translateAndUpdateDescriptionHk()} bText={"Translate & Save"} />				
						</div>
					</div>
				</>)
				
			}
			{
				(itemType == '84') && (<>
					<div style={{display:"flex", flexDirection:"row", alignItems:"center", justifyContent:"start"}}>
						<div style={{width:"80px"}}>Desc:</div>
						<textarea className={s.inputBox} type="text" rows="4" value={description} onChange={(e)=>{
							setDescription(e.target.value);
						}}/>
						<div>
							<GreenButton isEnabled={true} clickedAction={()=>updateDescription()} bText={"Update"} />
						</div>
					</div>
					<div style={{display:"flex", flexDirection:"row", alignItems:"center", justifyContent:"start"}}>
						<div style={{width:"80px"}}>HK Desc:</div>
						<textarea className={s.inputBox} type="text" rows="4" value={descriptionHk} onChange={(e)=>{
							setDescriptionHk(e.target.value);
						}}/>
						
						<div>
							<GreenButton isEnabled={true} clickedAction={()=>updateDescriptionHk()} bText={"Update"} />
						</div>
						<div>
							<GreenButton isEnabled={true} clickedAction={()=>translateAndUpdateDescriptionHk()} bText={"Translate & Save"} />				
						</div>
					</div>
				</>)
				
			}
			
			{(ItemConstant.VocabIts.includes(itemType)) && (<CategoryDisplay itemId={itemId}/>)}
			
			
		</div>);
	}